module.exports = __webpack_public_path__ + "static/media/logo.814646b0.png";